<app-dialog
	modalTitle="Importação de Arquivo"
	titleButton="Alterar"
	[secButton]="false"
	[asAlert]="true"
	(dialogClose)="dialogRef.close()"
	(dialogSave)="dialogRef.close()"
>
	<p class="lh-md">{{ data }}</p>
</app-dialog>
